import { createContext, useContext } from 'react';

export interface LoadingContextValues {
  loading: boolean;
  setLoading: (values: boolean) => void;
}

/**
 * @type {import("react").Context<LoadingContextValues>}
 * */

const LoadingContext = createContext<LoadingContextValues>({
  loading: true,
  setLoading: () => {},
});

export const useLoading = () => useContext(LoadingContext);

export { LoadingContext };
